import { getDate, getLocalisedDate, getLocalisedTime, secondsToHms } from "./datetime";

export const getNumberSuffix = (number) => {
  if (number > 3 && number < 21) return "th";
  switch (number % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  };
};

export const getLocalisedNumber = (number) => number.toLocaleString("en-IN");

export const getMean = (set, key, precision = 1) => {
  const total = set.reduce((accumulator, value) => (accumulator + value[key]), 0);
  return (total / (set.length + 1)).toFixed(precision);
};

export const deepClone = (object) => {
  let clone = Array.isArray(object) ? [] : {};

  let value;
  for (const key in object) {
    value = object[key];
    clone[key] = (typeof value === "object") ? deepClone(value) : value;
  }

  return clone;
}

export const ellipsisify = (string, length) => {
  if(!string) return "";
  else if(string.length <= length) return string;

  if(string.length > length) return `${string.substring(0, length)}...`
};

export const getUserAndVehicle = (data) => {
  return data.vehicles.map(vehicle => {
    let user = data.users.find(user => user.idx === vehicle.uid);
    let stat = data.stats.find(stat => stat.vid === vehicle.idx);
    if(user) vehicle["user"] = user;
    if(stat) vehicle["stat"] = stat;

    return vehicle;
  });
};

export const getDateTimeRows = (thresholdCrossedTimes) => {
  return (
    thresholdCrossedTimes.map(crossedTs => {
      return `${getDate(crossedTs, true, "/")} ${getLocalisedTime(crossedTs)}`;
    })
  );
};

const shortenNumber = (num) => {
  if (num >= 100000) {
    return (num / 100000).toFixed(1).replace(/\.0$/, "") + "L";
  }

  /*
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  }
  */

  return num;
};

/**
 * Gets Formatted Value with Units for a Stat
 * @param {Number} value                              - Raw Value for the Statistic
 * @param {('distance'|'duration'|'speed'|'time')} statType  - Type of Given Statistic
 * @param {Number} precision                          - Precision in Output
 * @param {Boolean} long                              - Prevent using abbreviations
 * @returns
 */
export const getStatLabel = (value, statType, precision, long, round) => {
  const getPlural = (val) => (val !== 1 ? "s" : "");
  const toKilometers = (val) => (val / 1000).toFixed(precision ?? (long ? 2 : 0));
  const renderValueWithUnit = (val, unit) => (
    <p>{val}<span>{unit}</span></p>
  );

  switch (statType) {
    case "time":
      return value
        ? getLocalisedTime(value * 1000, long, true, true)
        : "00:00:00";

    case "distance":
      let val = long ? toKilometers(value) : shortenNumber(toKilometers(value)).toLocaleString();
      return renderValueWithUnit(round ? (Math.floor(val)).toLocaleString() : val.toLocaleString(), " kms");

    case "duration": {
      if (!long) return secondsToHms(value || 0);

      const timeObj = secondsToHms(value, true);
      return (
        <p>
          {<>{(timeObj.h).toLocaleString()}<span> hrs </span></>}
          {/* {timeObj.m}<span> min{getPlural(timeObj.m)}</span> */}
        </p>
      );
    }

    case "speed": {
      if (isNaN(value) || value == null) return "N/A";
      const display = value < 250 ? value.toFixed(precision ?? (long ? 1 : 0)) : 250;
      return renderValueWithUnit(Math.round(display).toLocaleString(), " km/h");
    }

    case "date": {
      return getLocalisedDate(value, true);
    }

    default:
      return String(value.toFixed(precision ?? 0));
  }
};

export const getItemFromLocalStorage = (item) => {
  try {
    const storedUser = window.localStorage.getItem(item || "user");
    try{
      return storedUser ? JSON.parse(storedUser) : null;
    }
    catch(e){
      return storedUser ? storedUser : null;
    }
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
    return null;
  }
};

export const getFomattedAmt = (amt) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0
    }).format(amt || 0);
  }

export const getRidingStatus = (score) => {
  if (score >= 0 && score <= 35) return "Poor";
  if (score > 35 && score <= 70) return "Average";
  if (score > 70 && score <= 100) return "Excellent";
};